// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import MenuDefaultProps from "@insite/mobius/Menu/presentationProps";
import { MenuItemText } from "@werner/MobiusOverrides/Menu/Menu";
import { fontConfig } from "@werner/XDL/PreStyle/typography";
import { xBaseTheme } from "@werner/XDL/types";
import { color, ellipsis, styledScrollbar } from "@werner/XDL/Utilities";
import { css } from "styled-components";
import { StyledButton } from "@insite/mobius/Clickable";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";

const menuItemColorStyle = {
    default: {
        background: "transparent",
        text: "common.ui3",
        icon: "common.ui3",
    },
    active: {
        background: "secondary",
        text: "common.black",
        icon: "common.black",
    },
};

export default {
    defaultProps: {
        ...MenuDefaultProps,
        mergeCss: true,
        moreIconProps: {
            src: "ChevronRight",
            color: menuItemColorStyle.default.icon,
            size: 14,
            css: css`
                position: absolute;
                right: 12px;
                transform: translateY(-50%);
                top: 50%;
            `,
        },
        cssOverrides: {
            menu: css`
                padding: 16px 0 24px;
                max-height: 60vh;
                height: 60vh;
                box-shadow: -1px 0 0 0 ${color("common.border")};

                ${styledScrollbar()}

                & > .MenuItem[data-open] {
                    background: ${color(menuItemColorStyle.active.background)};
                    ${IconWrapper} {
                        color: ${color(menuItemColorStyle.active.icon)};
                    }
                    ${MenuItemText} {
                        color: ${color(menuItemColorStyle.active.text)};
                    }
                }

                ${({ referenceIndex }: any) => {
                    if (referenceIndex === 0) {
                        return css`
                            width: 445px;
                            position: relative;
                            &:after {
                                content: "";
                                position: absolute;
                                width: 1px;
                                height: 100%;
                                background: ${color("common.border")};
                                top: 0;
                                right: 0;
                            }
                        `;
                    }
                    return css`
                        width: 324px;
                    `;
                }}
            `,
            menuItem: css`
                ${StyledButton} {
                    padding: 6px 16px;
                    min-height: initial;
                    &:hover {
                        background: ${color(menuItemColorStyle.active.background)};

                        ${TypographyStyle}, ${IconWrapper} {
                            color: ${color(menuItemColorStyle.active.text)};
                        }
                    }
                }
            `,
        },
        menuItemTypographyProps: {
            color: menuItemColorStyle.default.text,
            size: 16,
            lineHeight: "19px",
            fontFamily: fontConfig.fontFamily,
            css: css`
                letter-spacing: 0.5px;
                box-sizing: border-box;
                ${ellipsis(1)};
            `,
        },
    },
} as xBaseTheme["menu"];
